/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSupply } from '../fn/supply/add-supply';
import { addSupply_1 } from '../fn/supply/add-supply-1';
import { AddSupply_1$Params } from '../fn/supply/add-supply-1';
import { AddSupply$Params } from '../fn/supply/add-supply';
import { deleteSupply } from '../fn/supply/delete-supply';
import { DeleteSupply$Params } from '../fn/supply/delete-supply';
import { listAllSuppliersForCombo } from '../fn/supply/list-all-suppliers-for-combo';
import { ListAllSuppliersForCombo$Params } from '../fn/supply/list-all-suppliers-for-combo';
import { listSupplierOrders } from '../fn/supply/list-supplier-orders';
import { ListSupplierOrders$Params } from '../fn/supply/list-supplier-orders';
import { listSuppliers } from '../fn/supply/list-suppliers';
import { ListSuppliers$Params } from '../fn/supply/list-suppliers';
import { listSupplies } from '../fn/supply/list-supplies';
import { listSupplies_1 } from '../fn/supply/list-supplies-1';
import { ListSupplies_1$Params } from '../fn/supply/list-supplies-1';
import { ListSupplies$Params } from '../fn/supply/list-supplies';
import { listSuppliesSimple } from '../fn/supply/list-supplies-simple';
import { ListSuppliesSimple$Params } from '../fn/supply/list-supplies-simple';
import { listUnitOfMeasurements } from '../fn/supply/list-unit-of-measurements';
import { ListUnitOfMeasurements$Params } from '../fn/supply/list-unit-of-measurements';
import { orderAndReorderSupply } from '../fn/supply/order-and-reorder-supply';
import { OrderAndReorderSupply$Params } from '../fn/supply/order-and-reorder-supply';
import { updateSupply } from '../fn/supply/update-supply';
import { UpdateSupply$Params } from '../fn/supply/update-supply';
import { viewSupply } from '../fn/supply/view-supply';
import { viewSupply_1 } from '../fn/supply/view-supply-1';
import { ViewSupply_1$Params } from '../fn/supply/view-supply-1';
import { ViewSupply$Params } from '../fn/supply/view-supply';

@Injectable({ providedIn: 'root' })
export class SupplyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listSupplies()` */
  static readonly ListSuppliesPath = '/api/mng/Supply/listsupplies';

  /**
   * List supplies for venue by venue id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSupplies()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSupplies$Response(params?: ListSupplies$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSupplies(this.http, this.rootUrl, params, context);
  }

  /**
   * List supplies for venue by venue id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSupplies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSupplies(params?: ListSupplies$Params, context?: HttpContext): Observable<void> {
    return this.listSupplies$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewSupply()` */
  static readonly ViewSupplyPath = '/api/mng/Supply/viewSupply';

  /**
   * View order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewSupply()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewSupply$Response(params?: ViewSupply$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewSupply(this.http, this.rootUrl, params, context);
  }

  /**
   * View order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewSupply$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewSupply(params?: ViewSupply$Params, context?: HttpContext): Observable<void> {
    return this.viewSupply$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `orderAndReorderSupply()` */
  static readonly OrderAndReorderSupplyPath = '/api/mng/Supply/orderandreordersupply';

  /**
   * Update Supply.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderAndReorderSupply()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  orderAndReorderSupply$Response(params?: OrderAndReorderSupply$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return orderAndReorderSupply(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Supply.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderAndReorderSupply$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  orderAndReorderSupply(params?: OrderAndReorderSupply$Params, context?: HttpContext): Observable<void> {
    return this.orderAndReorderSupply$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addSupply()` */
  static readonly AddSupplyPath = '/api/mng/Supply/addsupply';

  /**
   * Add supply to the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSupply()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addSupply$Response(params?: AddSupply$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addSupply(this.http, this.rootUrl, params, context);
  }

  /**
   * Add supply to the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSupply$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addSupply(params?: AddSupply$Params, context?: HttpContext): Observable<void> {
    return this.addSupply$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listUnitOfMeasurements()` */
  static readonly ListUnitOfMeasurementsPath = '/api/mng/Supply/listUnitOfMeasurements';

  /**
   * List Unit Of Measurements for Menager.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUnitOfMeasurements()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUnitOfMeasurements$Response(params?: ListUnitOfMeasurements$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listUnitOfMeasurements(this.http, this.rootUrl, params, context);
  }

  /**
   * List Unit Of Measurements for Menager.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUnitOfMeasurements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUnitOfMeasurements(params?: ListUnitOfMeasurements$Params, context?: HttpContext): Observable<void> {
    return this.listUnitOfMeasurements$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAllSuppliersForCombo()` */
  static readonly ListAllSuppliersForComboPath = '/api/mng/Supply/listallsuppliersforcombo';

  /**
   * List all suppliers for combo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllSuppliersForCombo()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllSuppliersForCombo$Response(params?: ListAllSuppliersForCombo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listAllSuppliersForCombo(this.http, this.rootUrl, params, context);
  }

  /**
   * List all suppliers for combo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllSuppliersForCombo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllSuppliersForCombo(params?: ListAllSuppliersForCombo$Params, context?: HttpContext): Observable<void> {
    return this.listAllSuppliersForCombo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listSuppliers()` */
  static readonly ListSuppliersPath = '/api/mng/Supply/listsuppliers';

  /**
   * List suppliers for menager.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSuppliers()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSuppliers$Response(params?: ListSuppliers$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSuppliers(this.http, this.rootUrl, params, context);
  }

  /**
   * List suppliers for menager.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSuppliers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSuppliers(params?: ListSuppliers$Params, context?: HttpContext): Observable<void> {
    return this.listSuppliers$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listSupplierOrders()` */
  static readonly ListSupplierOrdersPath = '/api/mng/Supply/listsupplierorders';

  /**
   * List supplier orders for menager.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSupplierOrders()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSupplierOrders$Response(params?: ListSupplierOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSupplierOrders(this.http, this.rootUrl, params, context);
  }

  /**
   * List supplier orders for menager.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSupplierOrders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSupplierOrders(params?: ListSupplierOrders$Params, context?: HttpContext): Observable<void> {
    return this.listSupplierOrders$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listSupplies_1()` */
  static readonly ListSupplies_1Path = '/api/gmn/Supply/listsupplies';

  /**
   * List orders for waiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSupplies_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSupplies_1$Response(params?: ListSupplies_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSupplies_1(this.http, this.rootUrl, params, context);
  }

  /**
   * List orders for waiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSupplies_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSupplies_1(params?: ListSupplies_1$Params, context?: HttpContext): Observable<void> {
    return this.listSupplies_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listSuppliesSimple()` */
  static readonly ListSuppliesSimplePath = '/api/gmn/Supply/listsuppliessimple';

  /**
   * List supplies for autocomplete.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSuppliesSimple()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSuppliesSimple$Response(params?: ListSuppliesSimple$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSuppliesSimple(this.http, this.rootUrl, params, context);
  }

  /**
   * List supplies for autocomplete.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSuppliesSimple$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSuppliesSimple(params?: ListSuppliesSimple$Params, context?: HttpContext): Observable<void> {
    return this.listSuppliesSimple$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewSupply_1()` */
  static readonly ViewSupply_1Path = '/api/gmn/Supply/viewSupply';

  /**
   * View order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewSupply_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewSupply_1$Response(params?: ViewSupply_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewSupply_1(this.http, this.rootUrl, params, context);
  }

  /**
   * View order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewSupply_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewSupply_1(params?: ViewSupply_1$Params, context?: HttpContext): Observable<void> {
    return this.viewSupply_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addSupply_1()` */
  static readonly AddSupply_1Path = '/api/gmn/Supply/addsupply';

  /**
   * Add supply to the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSupply_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addSupply_1$Response(params?: AddSupply_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addSupply_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Add supply to the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSupply_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addSupply_1(params?: AddSupply_1$Params, context?: HttpContext): Observable<void> {
    return this.addSupply_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateSupply()` */
  static readonly UpdateSupplyPath = '/api/gmn/Supply/updatesupply';

  /**
   * Update supply to the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSupply()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSupply$Response(params?: UpdateSupply$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSupply(this.http, this.rootUrl, params, context);
  }

  /**
   * Update supply to the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSupply$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSupply(params?: UpdateSupply$Params, context?: HttpContext): Observable<void> {
    return this.updateSupply$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSupply()` */
  static readonly DeleteSupplyPath = '/api/gmn/Supply/deletesupply';

  /**
   * Delete supply from the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSupply()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteSupply$Response(params?: DeleteSupply$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSupply(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete supply from the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSupply$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteSupply(params?: DeleteSupply$Params, context?: HttpContext): Observable<void> {
    return this.deleteSupply$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
